import { z } from 'zod';

/**
 * Пределы чисел во вводе. Суммы в базе — numeric(18,2), количества — numeric(18,5): берём с запасом,
 * чтобы произведения и итоги тоже помещались, а ошибка ввода не превращалась в сбой сервера.
 */
export const MONEY_MAX = 1e13;
export const QTY_MAX = 1e9;

export const MoneyNum = z
  .number()
  .finite()
  .min(-MONEY_MAX, 'Сумма слишком большая')
  .max(MONEY_MAX, 'Сумма слишком большая');

export const QtyNum = z
  .number()
  .finite()
  .min(-QTY_MAX, 'Количество слишком большое')
  .max(QTY_MAX, 'Количество слишком большое');
